import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

const token = localStorage.getItem('token')
window.Pusher = Pusher

const authEndpoint = import.meta.env.VITE_APP_BACKEND_BASE_URL + '/api/broadcasting/auth'

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: import.meta.env.VITE_PUSHER_APP_KEY,
  cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  forceTLS: true,
  encrypted: true,
  authEndpoint: authEndpoint,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  },
})
export default window.Echo
